import React from "react";

const EntityInfo = ({ id_340b, name, terminated, nowrap = false }) => {
  const vanityId340b = terminated ? `${id_340b} (Terminated)` : id_340b;

  return (
    <div className="tpa__entity__profile__container tpa__entity__profile__container--justify-start">
      <div className="flex__container justify-content-cetner align-items-center">
        <div className="tpa__entity__profile__avatar mr--8">
          <span className="material-symbols-rounded size-20">apartment</span>
        </div>
      </div>
      <div className="tpa__entity__profile__details">
        <div className="tpa__entity__profile__details__id tpa__entity__profile__details__id--bold">
          {vanityId340b}
        </div>
        <div className={`tpa__entity__profile__details__name ${nowrap ? " t--nowrap" : ""}`}>
          {name}
        </div>
      </div>
    </div>
  );
};

export default EntityInfo;
